// Shared helpers for normalizing federal and state rep data shapes.
// Used by SearchFlow, campaign pages (/m), and anywhere reps are rendered.

export const repSlug = (first: string, last: string) =>
  `${first}-${last}`.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

export const getRepId = (rep: any): string => rep?.references?.bioguide_id || rep?.id || '';

export const getRepFullName = (rep: any): string =>
  rep?.name || `${rep?.bio?.first_name || ''} ${rep?.bio?.last_name || ''}`.trim() || 'Unknown';

export const getRepTitle = (rep: any): string => {
  if (rep?.level === 'state') {
    if (rep?.jurisdiction === 'dc') return 'Council Member';
    return rep?.chamber === 'upper' ? 'State Senator' : 'State Representative';
  }
  return rep?.type === 'senator' ? 'U.S. Senator' : 'U.S. Representative';
};

export const getRepState = (rep: any): string =>
  (rep?.jurisdiction || rep?.bio?.state || '').toUpperCase();

export const getRepParty = (rep: any): string => rep?.party || rep?.bio?.party || 'Unknown';

// Profile page link. State reps go to their state hub — the search result
// shape has no slug, and the hub lists every member of that legislature.
export const getRepLink = (rep: any): string | null =>
  rep?.level === 'state'
    ? (rep?.jurisdiction ? `/rep/${String(rep.jurisdiction).toLowerCase()}` : null)
    : `/rep/${repSlug(rep?.bio?.first_name || '', rep?.bio?.last_name || '')}`;

export const US_STATES = [
  ['al','Alabama'],['ak','Alaska'],['az','Arizona'],['ar','Arkansas'],['ca','California'],
  ['co','Colorado'],['ct','Connecticut'],['de','Delaware'],['fl','Florida'],['ga','Georgia'],
  ['hi','Hawaii'],['id','Idaho'],['il','Illinois'],['in','Indiana'],['ia','Iowa'],
  ['ks','Kansas'],['ky','Kentucky'],['la','Louisiana'],['me','Maine'],['md','Maryland'],
  ['ma','Massachusetts'],['mi','Michigan'],['mn','Minnesota'],['ms','Mississippi'],['mo','Missouri'],
  ['mt','Montana'],['ne','Nebraska'],['nv','Nevada'],['nh','New Hampshire'],['nj','New Jersey'],
  ['nm','New Mexico'],['ny','New York'],['nc','North Carolina'],['nd','North Dakota'],['oh','Ohio'],
  ['ok','Oklahoma'],['or','Oregon'],['pa','Pennsylvania'],['ri','Rhode Island'],['sc','South Carolina'],
  ['sd','South Dakota'],['tn','Tennessee'],['tx','Texas'],['ut','Utah'],['vt','Vermont'],
  ['va','Virginia'],['wa','Washington'],['wv','West Virginia'],['wi','Wisconsin'],['wy','Wyoming'],
  ['dc','Washington D.C.'],['pr','Puerto Rico'],
] as const;
